import { DOCS_FORM_NAMES, RECARE_FILE_TYPE } from "core/consts";
import { DocsFormName, RecareFileType } from "core/types";

export const FORM_NAME_TO_FILE_TYPE: Record<DocsFormName, RecareFileType> = {
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_CARDIOLOGY]:
    RECARE_FILE_TYPE.DISCHARGE_LETTER_CARDIOLOGY,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_ENT]: RECARE_FILE_TYPE.DISCHARGE_LETTER_ENT,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_INTERNAL_MEDICINE]:
    RECARE_FILE_TYPE.DISCHARGE_LETTER_INTERNAL_MEDICINE,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_NEUROSURGERY]:
    RECARE_FILE_TYPE.DISCHARGE_LETTER_NEUROSURGERY,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_OBSTETRICS]:
    RECARE_FILE_TYPE.DISCHARGE_LETTER_OBSTETRICS,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_PNEUMOLOGY]:
    RECARE_FILE_TYPE.DISCHARGE_LETTER_PNEUMOLOGY,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_SURGERY]:
    RECARE_FILE_TYPE.DISCHARGE_LETTER_SURGERY,
  [DOCS_FORM_NAMES.DISCHARGE_LETTER_TRAUMA_SURGERY]:
    RECARE_FILE_TYPE.DISCHARGE_LETTER_TRAUMA_SURGERY,
  [DOCS_FORM_NAMES.DRV_GENERAL]: RECARE_FILE_TYPE.DRV_GENERAL_FORM,
  [DOCS_FORM_NAMES.DRV_MEDICAL]: RECARE_FILE_TYPE.DRV_MEDICAL_FORM,
  [DOCS_FORM_NAMES.GKV_GENERAL]: RECARE_FILE_TYPE.GKV_GENERAL_FORM,
  [DOCS_FORM_NAMES.GKV_MEDICAL]: RECARE_FILE_TYPE.GKV_MEDICAL_FORM,
  [DOCS_FORM_NAMES.TRANSITIONAL_CARE]: RECARE_FILE_TYPE.TRANSITIONAL_CARE,
};
